import { useEffect, useState } from "react";
import { Route, Routes, NavLink, Navigate, useNavigate } from "react-router-dom";
import { ClipboardList, Home, ListTodo, LogOut, MessageCircle, Trophy, Users } from "lucide-react";
import { Toaster } from "sonner";
import { techApi, TECH_TOKEN_KEY } from "../../lib/teknisiApi";
import TeknisiLogin from "./TeknisiLogin";
import TeknisiHome from "./TeknisiHome";
import TeknisiTasks from "./TeknisiTasks";
import TeknisiReports from "./TeknisiReports";
import TeknisiKinerja from "./TeknisiKinerja";
import TeknisiChat from "./TeknisiChat";
import TeknisiGroup from "./TeknisiGroup";
import TeknisiAlerts from "./TeknisiAlerts";

const NAV = [["/teknisi", "Beranda", Home, true], ["/teknisi/tugas", "Tugas", ListTodo], ["/teknisi/laporan", "Laporan", ClipboardList], ["/teknisi/chat", "Chat", MessageCircle], ["/teknisi/group", "Tim", Users], ["/teknisi/kinerja", "Kinerja", Trophy]];

export default function TeknisiPortal() {
  const [tech, setTech] = useState(undefined);
  const [unread, setUnread] = useState({ chat: 0, group: 0 });
  const nav = useNavigate();
  useEffect(() => {
    const check = () => { if (!localStorage.getItem(TECH_TOKEN_KEY)) return setTech(null); techApi.get("/auth/me").then((r) => setTech(r.data)).catch(() => setTech(null)); };
    check();
    const out = () => setTech(null);
    window.addEventListener("fasnet:tech-logout", out);
    return () => window.removeEventListener("fasnet:tech-logout", out);
  }, []);
  const logout = async () => { try { await techApi.post("/auth/logout"); } catch { /* ignore */ } localStorage.removeItem(TECH_TOKEN_KEY); setTech(null); nav("/teknisi"); };
  if (tech === undefined) return <div className="min-h-screen bg-[#0b1324] text-white flex items-center justify-center text-sm">Memuat…</div>;
  if (!tech) return <><Toaster position="top-center" richColors /><TeknisiLogin onLogin={setTech} /></>;
  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 flex flex-col max-w-md mx-auto shadow-xl" data-testid="teknisi-portal">
      <Toaster position="top-center" richColors />
      <header className="bg-[#0f2a6b] text-white px-4 py-3 flex items-center justify-between sticky top-0 z-20">
        <div className="flex items-center gap-2"><img src="/logo-fasnet.png" alt="" className="h-7 hidden" onLoad={(e) => e.currentTarget.classList.remove("hidden")} /><div><div className="font-extrabold text-sm tracking-wide">FASNET <span className="text-[#F04E23]">FIBER</span></div><div className="text-[10px] text-blue-200">Portal Teknisi · {tech.name}</div></div></div>
        <button type="button" onClick={logout} className="text-blue-200 hover:text-white" title="Keluar" data-testid="teknisi-logout"><LogOut className="w-5 h-5" /></button>
      </header>
      <main className="flex-1 p-3 pb-20 space-y-3">
        <TeknisiAlerts onUnread={setUnread} />
        <Routes>
          <Route index element={<TeknisiHome tech={tech} />} />
          <Route path="tugas" element={<TeknisiTasks />} />
          <Route path="laporan" element={<TeknisiReports />} />
          <Route path="chat" element={<TeknisiChat />} />
          <Route path="group" element={<TeknisiGroup tech={tech} />} />
          <Route path="kinerja" element={<TeknisiKinerja />} />
          <Route path="*" element={<Navigate to="/teknisi" replace />} />
        </Routes>
      </main>
      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-slate-200 grid grid-cols-6 z-20" data-testid="teknisi-nav">
        {NAV.map(([to, label, Icon, end]) => { const n = label === "Chat" ? unread.chat : label === "Tim" ? unread.group : 0; return <NavLink key={to} to={to} end={end} className={({ isActive }) => `relative flex flex-col items-center py-2 text-[10px] ${isActive ? "text-[#0f2a6b] font-bold" : "text-slate-500"}`} data-testid={`teknisi-nav-${label.toLowerCase()}`}><Icon className="w-5 h-5 mb-0.5" />{label}{n > 0 && <span className="absolute top-1 right-2 min-w-4 h-4 px-1 rounded-full bg-rose-500 text-white text-[9px] font-bold flex items-center justify-center" data-testid={`teknisi-${label.toLowerCase()}-unread`}>{n}</span>}</NavLink>; })}
      </nav>
    </div>
  );
}
